import { render, staticRenderFns } from "./DisOrder.vue?vue&type=template&id=063e7d52&scoped=true&"
import script from "./DisOrder.vue?vue&type=script&lang=js&"
export * from "./DisOrder.vue?vue&type=script&lang=js&"
import style0 from "./DisOrder.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DisOrder.vue?vue&type=style&index=1&id=063e7d52&lang=less&scoped=scoped&"
import style2 from "./DisOrder.vue?vue&type=style&index=2&id=063e7d52&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e7d52",
  null
  
)

export default component.exports